/**
 * 用户中心相关API接口
 */
import request from './utils/request'

/**
 * 获取当前企业信息（企业主体账号使用）
 * @returns {Promise} 企业信息
 */
export function getCurrentEnterprise() {
  return request({
    url: '/web/enterprise/getCurrentEnterpriseDetail',
    method: 'get'
  })
}

/**
 * 分页查询当前专项治理一级渠道下的子渠道（工作台子渠道管理）
 */
export function pageGovernanceSubChannels(params) {
  return request({
    url: '/web/enterprise/pageGovernanceSubChannels',
    method: 'get',
    params
  })
}

/**
 * 移除当前渠道下的专项治理子渠道（子渠道恢复为普通企业）
 * @param {number|string} id - 子渠道企业 id
 */
export function cancelGovernanceSubChannelUnderCurrentParent(id) {
  return request({
    url: '/web/enterprise/cancelGovernanceSubChannelUnderCurrentParent',
    method: 'post',
    params: { id }
  })
}

/**
 * 添加专项治理子渠道（短信校验联系人手机）
 * @param {Object} data - PortalSysEnterpriseDto：id, channelIdentityType, channelOrgName, linkmanPhone, verificationSmsCode；可选 channelOrgRemarks
 */
export function authorizeGovernanceSubChannelUnderCurrentParent(data) {
  return request({
    url: '/web/enterprise/authorizeGovernanceSubChannelUnderCurrentParent',
    method: 'post',
    data
  })
}

/**
 * 修改专项治理子渠道（名称、身份类型、备注）
 * @param {Object} data - { id, channelOrgName, channelIdentityType, channelOrgRemarks? }
 */
export function updateGovernanceSubChannelUnderCurrentParent(data) {
  return request({
    url: '/web/enterprise/updateGovernanceSubChannelUnderCurrentParent',
    method: 'post',
    data
  })
}

/**
 * 添加子渠道：按企业名称查询已实名认证的普通企业（须专项治理一级渠道，仅返回一条）
 */
export function getVerifiedNormalEnterpriseForSubChannel(params) {
  return request({
    url: '/web/portal/userCenter/getVerifiedNormalEnterpriseForSubChannel',
    method: 'get',
    params
  })
}

/**
 * 查询当前主体已加入的渠道产品的折扣信息
 * @param {number} productId - 产品枚举 ID（ProductServiceEnum）
 * @returns {Promise} 渠道名称与折扣
 */
export function getCurrentJoinedChannelProductDiscount(productId) {
  return request({
    url: '/web/enterprise/getCurrentJoinedChannelProductDiscount',
    method: 'get',
    params: { productId }
  })
}

/**
 * 根据 ID 查询企业信息
 * @param {number} id - 企业 ID
 * @returns {Promise} 企业信息
 */
export function getChannelById(channelId) {
  return request({
    url: '/web/enterprise/getChannelById',
    method: 'get',
    params: { channelId }
  })
}
